import React from "react";
import PropTypes from 'prop-types';
import { Dialog, DialogContent } from '@mui/material';

import { LoginForm } from "./login";
import { RegisterForm } from "./register";
import { Emailed } from "./emailed";
import { PassReset, RequestPassReset } from "./pass-reset";
import { SsoEmailCollection } from "./sso-email-collection";
import { ExitDialogTitle } from "./exit-dialog-title";

AuthModal.propTypes = {
    show: PropTypes.bool,
    type: PropTypes.string,
    onHide: PropTypes.func,
    regSuccessToastShow: PropTypes.bool,
    onShowRegToast: PropTypes.func,
};

export function AuthModal(props) {
    const { show, onHide, type } = props;

    const getBody = () => {
        switch(type) {
            case "login":
                return ( <LoginForm /> );
            case "register":
                return ( <RegisterForm /> );
            case "emailed":
                return ( <Emailed /> );
            case "request-password-reset":
                return ( <RequestPassReset /> );
            case "password-reset":
                return ( <PassReset /> );
            case "sso-email":
                return ( <SsoEmailCollection /> );
            default:
                throw new Error("invalid auth modal type specified");
        }
    }

    const getTitle = () => {
        switch(type) {
            case "login":
                return "Log in";
            case "register":
                return "Create Account";
            case "emailed":
                return "";
            case "request-password-reset":
                return "Password Reset";
            case "password-reset":
                    return "Set New Password";
            case "sso-email":
                return "Add Email Address";
            default:
                throw new Error("invalid auth modal type specified");
        }
    }
    return (
        <>
        <Dialog 
            open={show} 
            onClose={onHide} 
            maxWidth="xs"
            fullWidth={true}
        >
            <ExitDialogTitle id="modal-title" onClose={onHide}> {getTitle()} </ExitDialogTitle>
            <DialogContent sx={{px: 2}}> {getBody(type)} </DialogContent>
        </Dialog>
        </>
    );
}